import { useMutation } from '@tanstack/react-query';
import { addEducationHistory } from 'src/shared/services/fn-api/Beneficiary';

export const useAddEducationHistory = () => {
  return useMutation<Record<string, unknown>, Error, Record<string, unknown>>({
    mutationFn: async (data) => {
      return addEducationHistory(data);
    },
  });
};
